export default __webpack_public_path__ + "static/media/calibration-templates.adbd92e0.svg";